var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v("REGNAPARTS © "+_vm._s(new Date().getFullYear())+". Todos os direitos reservados.")]),_c('span',{staticClass:"md:flex hidden items-center"},[_c('feather-icon',{staticClass:"ml-2",attrs:{"icon":"HeartIcon","svgClasses":"stroke-current text-danger w-6 h-6"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }